/* eslint-disable no-redeclare */

import { z } from 'zod';

import { MemberBase } from './member-base';
import { MemberType } from './member-type';

// TODO validate 0 - 29
export const Child = MemberBase.extend({
  memberType: z.literal(MemberType.Enum.CHILD),
});

export type Child = z.infer<typeof Child>;
